import { renderRichText } from "@storyblok/react/rsc";
import { TextBlokProps } from "@/types/component.types";
import SectionWrapper from "@/components/ui/SectionWrapper";
import ContactHydrator from "@/components/security/ContactHydrator";
import Headline from "@/components/ui/Headline";

export default function Text({ blok }: { blok: TextBlokProps }) {
  
  let rawHtml = (renderRichText(blok.content) || "")
    .replace(/<p>\s*<\/p>/g, "")
    .replace(/<p>&nbsp;<\/p>/g, "");

  // anti-spam: mail/tel encoding
  const safeHtml = rawHtml.replace(
    /<a[^>]*href="(mailto|tel):([^"]+)"[^>]*>([^<]+)<\/a>/g,
    (_match, type, value, innerText) => {
      const encodedValue = Buffer.from(value).toString("base64");
      const encodedText = Buffer.from(innerText).toString("base64");
      
      return `<a href="#" data-contact-type="${type}" data-enc-val="${encodedValue}" data-enc-text="${encodedText}" class="protected-link">Kontakt laden...</a>`;
    }
  );

  const headlineBlok = blok.headline?.[0];

  return (
    <SectionWrapper
      className="container"
      spaces={blok.spaces}
      id={blok.id}
    >
      <div className="max-w-[810px] mx-auto">
        {headlineBlok && (
          <Headline
            className="mb-4 md:mb-8 xl:mb-12"
            text={headlineBlok.text}
            level={headlineBlok.level}
          />
        )}

        {blok.content && (
          <div className="prose" dangerouslySetInnerHTML={{ __html: safeHtml }} />
        )}
        <ContactHydrator />
      </div>
    </SectionWrapper>
  );
};